export default __webpack_public_path__ + "static/media/puppyFemaleBrown.17f582fd.jpg";